import React, { forwardRef, useImperativeHandle, useState } from "react";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";

const SubscriptionTableModal = forwardRef((props, ref) => {
    const [visible, setVisible] = useState(false);
    const [subscriptionData, setSubscriptionData] = useState([]);
    const [subscriptionTerms, setSubscriptionTerms] = useState("");

    useImperativeHandle(ref, () => ({
        show: (training) => {
            if (training?.registration_subscription_amount_mapping) {
                try {
                    const mapping = JSON.parse(training.registration_subscription_amount_mapping);
                    const data = Object.entries(mapping).map(([key, value]) => ({
                        students: parseInt(key),
                        amount: parseFloat(value)
                    })).sort((a, b) => a.students - b.students);
                    setSubscriptionData(data);
                } catch (error) {
                    console.error('Error parsing subscription mapping:', error);
                    setSubscriptionData([]);
                }
            } else {
                setSubscriptionData([]);
            }
            setSubscriptionTerms(training?.registration_subscription_terms || "");
            setVisible(true);
        }
    }));

    const formatAmount = (amount) => {
        return new Intl.NumberFormat('fr-FR', {
            style: 'currency',
            currency: 'EUR'
        }).format(amount);
    };

    const studentsTemplate = (rowData) => {
        return `${rowData.students} élève${rowData.students > 1 ? 's' : ''}`;
    };

    const amountTemplate = (rowData) => {
        return formatAmount(rowData.amount);
    };

    return (
        <Dialog
            header="Tableau des cotisations"
            visible={visible}
            style={{ width: '50vw' }}
            onHide={() => setVisible(false)}
            footer={
                <Button 
                    label="Fermer" 
                    icon="pi pi-times" 
                    onClick={() => setVisible(false)} 
                />
            }
        >
            <div className="flex flex-column gap-4">
                {subscriptionData.length > 0 ? (
                    <div>
                        <h4 className="mb-3">Tableau des montants</h4>
                        <DataTable 
                            value={subscriptionData} 
                            className="p-datatable-sm"
                            emptyMessage="Aucune donnée de cotisation disponible"
                        >
                            <Column 
                                field="students" 
                                header="Nombre d'élèves" 
                                body={studentsTemplate}
                                style={{ width: '50%' }}
                            />
                            <Column 
                                field="amount" 
                                header="Montant" 
                                body={amountTemplate}
                                style={{ width: '50%' }}
                            />
                        </DataTable>
                    </div>
                ) : (
                    <div className="text-center p-4">
                        <i className="pi pi-info-circle text-4xl text-500 mb-3"></i>
                        <p className="text-600">Aucune donnée de cotisation configurée</p>
                    </div>
                )}

                {subscriptionTerms && (
                    <div>
                        <h4 className="mb-3">Conditions de cotisation</h4>
                        <div 
                            className="border-1 surface-border border-round p-3 bg-gray-50"
                            dangerouslySetInnerHTML={{ __html: subscriptionTerms }}
                        />
                    </div>
                )}
            </div>
        </Dialog>
    );
});

export default SubscriptionTableModal;
